import React, { useState } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import Sidebar from '../components/layout/Sidebar'
import Header from '../components/layout/Header'
import UpdateOverlay from '../components/layout/UpdateOverlay'

const MainLayout = ({ searchTerm, setSearchTerm, runningGames }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const getActivePage = () => {
        const path = location.pathname;
        if (path === '/app' || path === '/app/') return 'discover';
        if (path === '/app/library') return 'library';
        if (path.startsWith('/app/mods')) return 'mods';
        if (path === '/app/active-mods') return 'active-mods';
        if (path === '/app/favorites') return 'favorites';
        if (path === '/app/settings') return 'settings';
        if (path === '/app/admin') return 'admin';
        if (path === '/app/admin/logs') return 'admin/logs';
        return 'discover'; // fallback to discover if unknown
    };

    const handleNavigate = (page) => {
        switch (page) {
            case 'discover':
                navigate('/app');
                break;
            case 'library':
                navigate('/app/library');
                break;
            case 'mods':
                navigate('/app/mods');
                break;
            case 'active-mods':
                navigate('/app/active-mods');
                break;
            case 'favorites':
                navigate('/app/favorites');
                break;
            case 'settings':
                navigate('/app/settings');
                break;
            case 'admin':
                navigate('/app/admin');
                break;
            case 'admin/logs':
                navigate('/app/admin/logs');
                break;
            default:
                navigate('/app');
        }
    };

    return (
        <div className="min-h-screen bg-transparent flex relative overflow-hidden">
            <UpdateOverlay />
            
            {/* Themed Background Elements - Executive Pulse */}
            <div className="fixed inset-0 pointer-events-none z-0">
                <div className="absolute top-[-10%] right-[-5%] w-[800px] h-[800px] bg-accent-primary/5 rounded-full blur-[120px] mix-blend-screen opacity-60 animate-pulse" style={{ animationDuration: '8s' }} />
                <div className="absolute bottom-[-20%] left-[-10%] w-[600px] h-[600px] bg-accent-secondary/5 rounded-full blur-[100px] mix-blend-screen opacity-50" />
                <div className="absolute inset-0 bg-grid-pattern opacity-30 mask-image:linear-gradient(to_bottom,white,transparent)" style={{ WebkitMaskImage: 'linear-gradient(to bottom, black 20%, transparent 100%)' }} />
            </div>

            {/* Sidebar Floating over the canvas */}
            <Sidebar 
                currentPage={getActivePage()} 
                onNavigate={handleNavigate} 
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                runningGames={runningGames}
            />

            <div className={`flex-1 flex flex-col relative z-10 min-h-screen transition-all duration-300 ease-[cubic-bezier(0.2,0.8,0.2,1)] lg:ml-20`}>
                <main className="flex-1 p-6 md:p-12 overflow-x-hidden animate-fadeIn pt-12">
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default MainLayout;
